import { CaseState } from 'app/area/case/types-store';
import { childEntities } from 'app/area/case/selectors/entities';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export const childEntityTypeKeys = (state: CaseState, uiEngineProps: ConnectedComponentProps, fullState: any) => {

    const result = childEntities(state, uiEngineProps);

    const existing = result && result.childEntities.map(e => e.primaryKey);

    return { 
      existingKeys: existing || []
    };
};
